import api from "../apiInstance";
import { AddDiscountCodeData, DiscountCodeModel, EditDiscountCodeData } from "./interfaces/DiscountCode";

export const getDiscountCodes = async (): Promise<DiscountCodeModel[]> => {
    const res = await api.get<DiscountCodeModel[]>(process.env.REACT_APP_RENTIC_API_URL! + '/products/discount_codes');
    return res.data;
}

export const createDiscountCode = async (data: AddDiscountCodeData): Promise<DiscountCodeModel> => {
    const res = await api.post<DiscountCodeModel>(process.env.REACT_APP_RENTIC_API_URL! + '/products/add_discount_code', data);
    return res.data;
}

export const editDiscountCode = async (discountCodeId: number, data: EditDiscountCodeData): Promise<boolean> => {
    const res = await api.patch<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/products/edit_discount_code/' + discountCodeId.toString(), data);
    return res.data;
}

export const deleteDiscountCode = async (discountCodeId: number): Promise<boolean> => {
    const res = await api.delete<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/products/delete_discount_code/' + discountCodeId.toString());
    return res.data;
}